<!-- 账号管理 -->
<template>
    <div class='container containerBox'>
        <div class="handle-box">
            <!-- <el-input v-model="select_word" placeholder="请输入用户名" clearable class="handle-input mr10"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
             -->
            <el-button type="primary" icon="el-icon-plus" @click="addRole">新增模块</el-button>
        </div>

        <el-table :data="tableList" border class="table" ref="multipleTable">
            <el-table-column prop="ModuleName" label="模块名称">
            </el-table-column>
            <el-table-column prop="ModuleKey" label="模块Key">
            </el-table-column>
            <el-table-column prop="Routing" label="路由">
            </el-table-column>
            <el-table-column prop="Enable" label="使用状态" sortable>
                <template slot-scope="scope">
                    <el-tag :type="scope.row.Enable ? 'success': 'danger'">{{scope.row.Enable ? "可用" : "禁用"}}</el-tag>
                </template>   
            </el-table-column>
            <el-table-column prop="Order_id" label="排序" sortable>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 编辑框 -->
        <el-dialog :title="dialogTitle" :visible.sync="editVisible" width="40%" :before-close="dialogClose">
            <el-form ref="roleForm" class="roleForm" :rules="rules" :model="form" label-width="100px">
                <el-form-item label="模块名称" prop="module_name">
                    <el-input v-model="form.module_name"></el-input>
                </el-form-item>
                <el-form-item label="模块Key" prop="module_key" v-if="!form.oid">
                    <el-input v-model="form.module_key"></el-input>
                </el-form-item>
                <el-form-item label="路由" prop="routing">
                    <el-input v-model="form.routing"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="order_id">
                    <el-input v-model="form.order_id"></el-input>
                </el-form-item>
                <el-form-item label="使用状态" prop="enable">
                    <el-select v-model="form.enable" placeholder="请选择使用状态">
                        <el-option label="可用" :value="true"></el-option>
                        <el-option label="禁用" :value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'

export default {
    name:  'companymana',
    inject: ["reload"],
    data() {
        return {
            select_word: '',

            tableList: [],

            editVisible: false, // 编辑弹框
            form: {}, //  编辑框表单内容
            dialogTitle: "新增",

            // 编辑框验证规则
            rules: {
                module_name: [
                    {
                        required: true,
                        message: "请输入模块名称",
                        trigger: "blur"
                    }
                ],
                module_key: [
                    {
                        required: true,
                        message: "请输入模块Key",
                        trigger: "blur"
                    }
                ],
                enable: [
                    { required: true, message: "请选择使用状态", trigger: "change" }
                ]
            }
        };
    },

    mounted() {},
    created() {
        this.getRoleModuleList()
    },

    methods: {
        // 查询
        search() {

        },
        // 获取账号列表
        async getRoleModuleList() {
            let data = await Service.getRoleModuleList()
            if(data) {
                data = data =='success' ? [] : data;
                this.tableList = data;
            }
        },
        // 新增账户
        addRole() {
            this.dialogTitle = "新增";
            this.editVisible = true;
            this.form = {};
        },
        dialogClose(done) {
            this.$refs["roleForm"].resetFields();
            done();
        },
        // 编辑
        handleEdit(row) {
            this.form = {
                module_name: row.ModuleName,
                module_key: row.ModuleKey,
                order_id: row.Order_id,
                enable: row.Enable,
                routing: row.Routing,
                oid: row.OID,
            }
            this.dialogTitle = "编辑";
            this.editVisible = true;
        },
        // 删除
        handleDelete(data) {
            $Alert(`是否确认删除 ${data.Module_name} `).then( async (bool)=>{
                if(bool){
                    let res = await Service.getDeletRoleModule({oid: data.OID});
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.reload();
                    }
                }
           });
        },
        // 新增
        saveEdit() {
            this.$refs["roleForm"].validate(valid => {
                if (valid) {
                    if(this.form.oid) {
                        // 编辑
                        this.editModule()
                    } else{
                        // 添加
                        this.addModule()
                    }
                    
                } else {
                    return false;
                }
            });
        },
        async addModule() {
            
            let data = await Service.getAddRoleModule(this.form);
            if(data) {
                this.$message({
                    type: 'success',
                    message: '操作成功!',
                    duration: 1500,
                });
                this.reload()
            }
        },
        async editModule() {
            let data = await Service.getEditRoleModule(this.form);
            if(data) {
                this.$message({
                    type: 'success',
                    message: '操作成功!',
                    duration: 1500,
                });
                this.reload()
            }
        }
    }
}

</script>
<style lang='less' scoped>

</style>